import script from "./Application.vue?vue&type=script&setup=true&lang=js"
export * from "./Application.vue?vue&type=script&setup=true&lang=js"

import "./Application.vue?vue&type=style&index=0&id=ede77aec&scoped=true&lang=scss"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ede77aec"]])

export default __exports__